'use client';

import { Button, Tag } from '@/components';
import { Column, Divider, Element, Icon, Row } from '@vuddy/components';
import clsx from 'clsx';
import { useMemo } from 'react';
import * as styles from './fundingStatusWithContribution.css';

interface IFundingStatusWithContributionProps {
  myOrderAmount: number;
  myOrderAmountRate: number;
  achievementRate: number;
  daysLeft: number;
  onClick?: VoidFunction;
  isFullWidth?: boolean;
}

export const FundingStatusWithContribution = ({
  myOrderAmount,
  myOrderAmountRate,
  achievementRate,
  daysLeft,
  onClick,
  isFullWidth,
}: IFundingStatusWithContributionProps) => {
  const isAchieved = useMemo(() => achievementRate >= 100, [achievementRate]);
  const label = `${daysLeft}일 남음`;
  const color = daysLeft > 3 ? 'lightblue' : 'lightred';

  const handleClick = () => {
    onClick?.();
  };

  return (
    <Column
      className={clsx(
        isFullWidth ? styles.containerFullWidth : styles.container,
        isAchieved && styles.achieved
      )}>
      <Row justifyContent="space-between">
        <Element color="vuddyPrimary" typography="titleBase">
          {achievementRate}%{isAchieved && <>{' 🎉'}</>}
        </Element>
        <Row color="danger" alignItems="center">
          <Element typography="bodyXsAccent">{myOrderAmountRate}%</Element>
          <Icon name="FILL_TRIANGLE_UP" size="16px" />
        </Row>
      </Row>
      <Row justifyContent="space-between" alignItems="center" gap="gap_small">
        <Element className={styles.progressContainer}>
          <Element
            className={styles.progressBarNew}
            style={{ width: `${Math.min(achievementRate, 100)}%` }}
          />
        </Element>
      </Row>

      {/* 달성률에 따른 메시지 */}
      {isAchieved && (
        <Row
          borderRadius="radius_small"
          backgroundColor="vuddyQuaternary"
          justifyContent="center"
          alignItems="center"
          paddingX="padding_xs"
          paddingY="padding_3xs">
          <Element typography="captionBaseAccent" color="vuddyPrimary">
            펀딩 목표 달성! 소중한 응원에 감사드립니다!
          </Element>
        </Row>
      )}
      <Row gap="gap_small">
        <Element typography="captionBase" color="tertiary">
          나의 기여도
        </Element>
        <Divider direction="vertical" width={1} />
        <Element typography="captionBaseAccent">
          {myOrderAmount.toLocaleString() + '원'}
        </Element>
      </Row>
      <Row
        justifyContent="space-between"
        alignItems="center"
        marginTop="gap_small">
        <Tag label={label} variant={color} size="medium" />
        <Button variant="outlineSecondary" size="small" onClick={handleClick}>
          추가 주문하기
        </Button>
      </Row>
    </Column>
  );
};
